import React from 'react'

import { Layout } from '../components/Layout'
import SEO from '../components/seo'
import { Logo } from '../components/Logo'
import { SocialButtons } from '../components/SocialButtons'
import { Footer } from '../components/Footer'
import styles from './about.module.scss'
import Estimate from '../assets/UI_About.svg'
import { useAbout } from '../hooks/useAbout'
import Decoration from '../components/Decoration'

const About = () => {
  const { appTitle, appDescription, z1Description, z1Title } = useAbout()

  return (
    <Layout>
      <SEO title="App Calculator" />
      <header className="app-header">
        <div className="header-content mobile-big">
          <Logo />
          <SocialButtons hideInMobile={true} justifyRight={true} />
        </div>
      </header>
      <main className={`app-main`}>
        <Decoration />

        <div className="content-wrapper">
          <article className={`${styles.container} side-padding`}>
            <section className={styles.aboutApp}>
              <Estimate className={styles.icon} />

              <h1 className={styles.title}>{appTitle}</h1>
              <p
                className={styles.caption}
                dangerouslySetInnerHTML={{ __html: appDescription }}
              />
            </section>
            <section className={styles.aboutZ1}>
              <svg
                width="20px"
                height="14px"
                viewBox="0 0 20 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.icon}
              >
                <g id="How-much-to-make-an-app" stroke="none" fill="none">
                  <g
                    id="Desktop-HD"
                    transform="translate(-203.000000, -986.000000)"
                    fill="#0F0322"
                  >
                    <g
                      id="Footer"
                      transform="translate(135.000000, 937.000000)"
                    >
                      <g
                        id="Signature"
                        transform="translate(0.000000, 49.000000)"
                      >
                        <polygon
                          id="Z1-logo"
                          points="72.3949375 0 70.9914357 2.51277555 79.7912439 2.51277555 75.9414977 9.40532027 80.6710024 9.40532027 80.6722873 11.4872069 72.3489283 11.4872069 76.1964013 4.59811502 69.8323606 4.58809211 68.4301931 7.09861371 71.8515253 7.10403279 68 13.9999345 80.6710024 13.9999345 83.2604633 13.9999345 83.2604633 6.89254472 80.290426 6.89254472 81.4535041 4.8101306 85.4105885 4.8101306 85.4105885 13.9999345 88 13.9999345 88 2.29735505 82.8570553 2.29735505 84.1401723 0"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>

              <h1 className={styles.title}>{z1Title}</h1>
              <p
                className={styles.caption}
                dangerouslySetInnerHTML={{ __html: z1Description }}
              />
            </section>
          </article>

          <Footer className="footer--home" socialButtons={true} />
        </div>
      </main>
    </Layout>
  )
}

export default About
